// Warning to remove Adblock
    $(document).ready(function() {
        setTimeout(function(){
            $('#disable_adblock').removeClass('d-none');
        },750);
        $('#iframe').on('load', function(){
            $('#disable_adblock').hide();
        });
    });